module.exports = __webpack_public_path__ + "img/icon_jingduo.62c20b35.png";